import axios from 'axios';

const API_BASE_URL = 'https://auth.bingeit.vip/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("casdoor_access_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const language = navigator.language || 'en';
    config.headers['Accept-Language'] = language;
    return config;
  },
  (error) => Promise.reject(error)
);

export const AuthAPI = {
  profile: () => api.get('/auth/profile'),
  logout: () => api.post('/auth/logout'),
};

export const MovieAPI = {
  getUpcoming: (page = 1, pageSize = 20) =>
    api.get(`/media/upcoming?page=${page}&pageSize=${pageSize}`),
  search: (query, page = 1, pageSize = 20) =>
    api.get(`/media/search?q=${encodeURIComponent(query)}&page=${page}&pageSize=${pageSize}`),
  getMovie: (id) => api.get(`/media/movies/${id}`),
  addToWatchlist: (movieId) => api.post('/media/watchlist', { movieId }),
};

export const RequestAPI = {
  getRequests: (page = 1, pageSize = 20) =>
    api.get(`/media/requests?page=${page}&pageSize=${pageSize}`),
  createRequest: (data) => api.post('/media/requests', data),
  upvoteRequest: (id) => api.post(`/media/requests/${id}/upvote`),
};

export const CommunityAPI = {
  getPosts: (page = 1, pageSize = 20) =>
    api.get(`/community/posts?page=${page}&pageSize=${pageSize}`),
  createPost: (data) => api.post('/community/posts', data),
  likePost: (postId) => api.post(`/community/posts/${postId}/like`),
};

export const PaymentAPI = {
  getPlans: (owner = 'built-in') =>
    api.get(`/get-plans?owner=${owner}`),
  createOrder: (productInfos, userName = '', owner = 'built-in') =>
    api.post(`/place-order?owner=${owner}&userName=${userName}`, { productInfos, couponCode: '' }),
  getPaymentUrl: (orderId, providerName = 'provider_payment_paypal') =>
    api.post(`/pay-order?id=${orderId}&providerName=${providerName}`),
  verifyPayment: (orderId) => api.get(`/get-order?id=${orderId}`),
};

export const UserAPI = {
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data),
  getOrders: (page = 1, pageSize = 20) =>
    api.get(`/orders?page=${page}&pageSize=${pageSize}`),
};

export default api;
